import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSignIn } from '../../../hooks/auth';

export const useMinigamesAuth = (): { isUserAuthenticated: boolean; isAuthLoading: boolean } => {
  const auth = useAuth();
  const isUserAuthenticated = auth?.isAuthenticated;
  const isAuthLoading = auth?.isLoading;
  const authInitialized = useRef(false);
  const signIn = useSignIn();

  useEffect(() => {
    if (isAuthLoading) {
      return;
    }

    if (!isUserAuthenticated && !authInitialized.current) {
      authInitialized.current = true;
      signIn();

      return;
    }
  }, [isUserAuthenticated, isAuthLoading]);

  useEffect(() => {
    if (!isUserAuthenticated || !auth.user?.expires_at) return;

    const expiresAt = auth.user.expires_at;
    const now = Math.floor(Date.now() / 1000);
    const timeUntilExpiry = expiresAt - now;

    const refreshIn = Math.max(timeUntilExpiry - 60, 5);

    console.log(
      `[MinigamesPage] Token expires at ${new Date(expiresAt * 1000).toLocaleTimeString()}, scheduling refresh in ${refreshIn}s`
    );

    const timeout = setTimeout(async () => {
      console.log('[MinigamesPage] Refreshing token now...');
      try {
        await auth.signinSilent();
        console.log('[MinigamesPage] Token refreshed successfully');
      } catch (error) {
        console.error('[MinigamesPage] Failed to refresh token:', error);
      }
    }, refreshIn * 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [auth.user?.expires_at, isUserAuthenticated]);

  return { isUserAuthenticated, isAuthLoading };
};
